import { Resource } from 'cesium';
import MapIcon from '@vtx/map-icon/lib/map-icon';

// 在 drawCanvas 函数外定义一个缓存 map
const iconCache = new window.Map();

// 加载图片
const loadCachedImage = (url, options) => {
    // 根据参数生成key
    const key = `${url}_${JSON.stringify(options)}`;
    if (iconCache.has(key)) {
        return Promise.resolve(iconCache.get(key));
    }

    return Resource.fetchImage({ url }).then(image => {

        iconCache.set(key, image);
        return image;
    });
};

// 获取图标
const getMapIcon = (type, options = {}) => {
    // 根据参数生成key
    const key = `${type}-${JSON.stringify(options)}`;

    // 判断是否有缓存
    if (iconCache.has(key)) {
        // 直接从缓存中获取
        return iconCache.get(key);
    }

    // 生成图标
    const imgUrl = new MapIcon[type](options);

    // 存入缓存
    iconCache.set(key, imgUrl);

    return imgUrl;
}

// 根据图片和文字绘制 canvas
const customClusterStyle = (img, options) => {
    let {type, text, width, height, x, y, ...other} = options;
    // 通过 map-icon 中的聚合图标绘制

    const icon = getMapIcon(type || 'CommonIcon2', {
        hideFooter: true,
        info: { text: text, fontSize: 18 },
        ...other
    })

    const ctx = icon.ctx;

    // 大小
    width = width || 22;
    height = height || 22;

    // 起始位置
    x = x || (icon.settings.iconWrapSize / 2 - width / 2);
    y = y || (icon.settings.iconWrapSize / 2 - height / 2);

    return loadCachedImage(img, {text, width, height, x, y, ...other}).then(image => {
        // 插入图标
        ctx.drawImage(image, x, y, width, height);

        return icon.getCanvas()
    });
};

export default customClusterStyle;
